export default __webpack_public_path__ + "static/media/char_head_004.e7153943.png";